<template>
  <el-select
    class="stock-group-select"
    size="small"
    :value="value"
    clearable
    placeholder="Select a group"
    @change="handleChange"
  >
    <el-option
      v-for="item in groups"
      :label="getLabel(item)"
      :key="item.key"
      :value="item.key"
    >
      <div class="f-r-c-sb">
        <div>{{ item?.riiContainerNo ?? 'Local' }}</div>
        <div style="width: 10px;"></div>
        <div>{{ item.containerNo ?? 'Local' }}</div>
        <div style="width: 10px;"></div>
        <address-tag :address="item.address" />
      </div>
    </el-option>
  </el-select>
</template>
<script>
import AddressTag from '../address/AddressTag.vue'
export default {
  name: 'StockGroupSelect',
  components: { AddressTag },
  props: {
    groups: {
      type: Array,
      required: true
    },
    value: {
      required: true
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    getLabel(item) {
      const containerKey = item?.riiContainerNo ?? 'Local'
      const address =
        item?.address?.code ?? item?.address?.street + ', ' + item.address?.city
      return containerKey + ' - ' + address
    },
    handleChange(key) {
      this.$emit('input', key)
      this.$emit('change', key)
    }
  }
}
</script>
<style lang="scss" scoped>
//
</style>
